<div class="place-in-order-container">

  <div class="header">
    <div>{{title}} </div>
    <fi-button
      variant="tertiary"
      tone="neutral"
      size="lg"
      [iconOnly]="true"
      (click)="closeDialog()"
    >
      <mat-icon fiButtonIcon>close</mat-icon>
      <span fiTranslation="ALT_TEXT_DIALOG_CLOSE"></span>
    </fi-button>
  </div>

  <div class="main-container">
    <div class="horizontal-container">
      <fi-request-contacts [contactToDisplay]="contactToDisplay" [companyContacts]="companyContacts"></fi-request-contacts>
      @if (leadOfferId.includes(leadTypeId)) {
        <div class="form">
          <div class="form-title external-only">{{ title }}<span class="badge" fiTranslation="REQUEST_CREATE_APPOINTMENT_BADGE_EXTERNAL_ENQUIRY"></span></div>
          @if (!composerOrders?.length) {
            <div class="info-container">
              <div class="title">
                <img src="assets/icons/update.svg" alt="update">
                <span class="title-text" fiTranslation="REQUEST_DETAIL_HEADER_MENU_ORDER_EMPTY_HEADLINE"></span>
              </div>
              <div class="description" [hasHTMLTags]="true" fiTranslation="ACTION_ORDER_PLACED_INFO_TEXT_DESCRIPTION">
              </div>
            </div>
          }
          @if (composerOrders?.length) {
            <table class="orders-table">
              <tr>
                <th fiTranslation="REQUEST_DETAIL_HEADER_MENU_ORDER"></th>
                <th fiTranslation="REQUEST_DETAIL_HEADER_MENU_VALUE"></th>
              </tr>
              @for (order of composerOrders; track order) {
                <tr>
                  <td>
                    {{ order.Name }}
                  </td>
                  <td>
                    {{ order.Amount | appCurrency: order.CurrencyCode }}
                  </td>
                </tr>
              }
            </table>
          }
          <div>
            <div class="field-title" fiTranslation="ACTION_GENERAL_HEADLINE_REQUEST_NOTE2"></div>
            <fi-editor
              [noUploads]="true"
              [placeholderTranslation]="'REQUEST_DETAIL_NOTE_PLACEHOLDER'"
              (isLongDescription)="inValidNote = $event"
              (textChanged)="placeInOrder.Comment = $event">
            </fi-editor>
          </div>
        </div>
      }
    </div>
  </div>

  <div class="footer">
    <button (click)="submit()" [disabled]="!formIsValid">
      <img [src]="iconUrl" alt="Action icon">
      <span> {{title}} </span>
      @if (isExternal) {
        <span class="external" fiTranslation="External"></span>
      }
    </button>
  </div>
</div>
